import { useHttpClient, } from '@/common/api/httpClient';
import { useMapStyleStore } from 'shared/mapStyles/stores/mapStyleStore';
import type { MapStyle } from 'shared/mapStyles/domain/mapStyle';
import { createMapStyle } from 'shared/mapStyles/domain/createMapStyle';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import type { MapStyleResponse } from 'shared/mapStyles/api/mapStyleResponse';

export interface ListMapStylesResponse {
  styles: MapStyleResponse[];
}

export function useListMapStyles() {
  const httpClient = useHttpClient();
  const store = useMapStyleStore();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute() {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('mapStyle'), {
      method: 'GET',
      headers,
    });

    const text = translations.value.mapStyles.actions.fetchMany;

    const response = await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as ListMapStylesResponse;

        json.styles.sort((a, b) => a.name.localeCompare(b.name, undefined, {
          numeric: true
        }));

        return {
          ok: true,
          styles: json.styles
        };
      },
    });

    if (response.ok) {
      const styles: MapStyle[] = [];

      for (const style of response.styles) {
        styles.push(createMapStyle({
          style: style
        }).mapStyle);
      }

      store.mergeList(styles);
    }

    return response;
  }
}
